// extracted by mini-css-extract-plugin
module.exports = {"searchBar":"SearchBar_searchBar__2P-C0","input":"SearchBar_input__290l5","button":"SearchBar_button__1UZPb"};